/** Discriminator for Tree.customSource routing — keep in sync with logictry_server/utils/customSourceType.js */
export const CustomSourceType = {
  LIVE_STREAM: 'LiveStream',
  CUSTOM_APP: 'CustomApp',
  APP_TEMPLATE: 'AppTemplate',
  URL: 'Url',
};

/** Resolve type for API JSON or Tree model. */
export function resolveCustomSourceType(customSource) {
  if (!customSource) return null;
  if (customSource.type) return customSource.type;
  if (customSource.url) return CustomSourceType.URL;
  return null;
}

export function isLiveStreamCustomSource(customSource) {
  return resolveCustomSourceType(customSource) === CustomSourceType.LIVE_STREAM;
}
